module.exports = ".margin{\r\n    margin-top: 5%;\r\n}"